var Accident = (function(){

    function Accident(){
        THREE.Object3D.call(this);

        var geometry = new THREE.SphereGeometry(50);
        var material = new THREE.MeshBasicMaterial({color: 0x3facc8, wireframe: true, transparent: true});
        this.mesh = new THREE.Mesh(geometry, material);
        this.add(this.mesh);

        this.update();
    }

    Accident.prototype = new THREE.Object3D;
    Accident.prototype.constructor = Accident;

    Accident.prototype.update = function() {
        var vert, save;
        for(var i = 0, l = this.mesh.geometry.vertices.length; i < l; i++) {
            vert = this.mesh.geometry.vertices[i];
            vert.x += Math.random() * 20 - 10;
            vert.y += Math.random() * 20 - 10;
            vert.z += Math.random() * 20 - 10;
        }
        this.mesh.geometry.verticesNeedUpdate = true;
    };

    return Accident;
})();